import moment from 'moment'

/**
 * Most methods can accept either ES6 Date objects or Moment objects as
 * date parameters. They will intelligently return a value of the same type.
 */
const DateTimeUtils = {

  /**
   * Returns an array of weekdays that appear within the specified date range.
   * Days are specified as 0 (Sunday) through 6 (Saturday).
   */
  getWeekdaysInDateRange: function (startDate, endDate) {

    const momentStartDate = moment(startDate)
    const momentEndDate = moment(endDate)

    const weekdays = []

    const oneWeekAfterStartDate = moment(momentStartDate).add(6, 'days')
    const effectiveEndDate = momentEndDate > oneWeekAfterStartDate ? oneWeekAfterStartDate : momentEndDate

    for (const currentDate = moment(momentStartDate); currentDate.isSameOrBefore(effectiveEndDate); currentDate.add(1, 'days')) {
      weekdays.push(currentDate.day())
    }

    return weekdays.sort()

  },

  /**
   * Returns the first Monday that falls on or before the specified date.
   */
  stepBackToNearestMonday: function (date) {

    const momentDate = moment(date)

    const daysToStepBack = {
      0: 6, // sun
      1: 0, // mon
      2: 1, // tue
      3: 2, // wed
      4: 3, // thu
      5: 4, // fri
      6: 5, // sat
    }

    const currentWeekday = momentDate.day()
    let adjustedMomentDate = momentDate
      .clone()
      .subtract(daysToStepBack[currentWeekday], 'days').startOf('day')
    
    return moment.isMoment(date) ? adjustedMomentDate : adjustedMomentDate.toDate()

  },

  /**
   * Returns the first Sunday that falls on or after the specified date.
   */
  stepForwardToNearestSunday: function (date) {

    const momentDate = moment(date)

    const daysToStepForward = {
      0: 0, // sun
      1: 6, // mon
      2: 5, // tue
      3: 4, // wed
      4: 3, // thu
      5: 2, // fri
      6: 1, // sat
    }

    const currentWeekday = momentDate.day()
    let adjustedMomentDate = momentDate
      .clone()
      .add(daysToStepForward[currentWeekday], 'days').startOf('day')
    
    return moment.isMoment(date) ? adjustedMomentDate : adjustedMomentDate.toDate()

  },

  /**
   * Given a date range, returns an array of smaller date ranges, such that
   * no range is longer than maxDays.
   */
  chunkDateRange: function (startDate, endDate, maxDays = 30) {

    if (endDate < startDate) {
      throw 'endDate cannot be before startDate'
    }

    if (maxDays < 1) {
      throw 'maxDays must be at least 1'
    }

    const momentStartDate = moment.utc(startDate)
    const momentEndDate = moment.utc(endDate)

    const output = []
    const currentRangeStart = momentStartDate.clone()

    do {

      let currentRangeEnd = currentRangeStart.clone().add(maxDays - 1, 'day')
      if (currentRangeEnd > momentEndDate) {
        currentRangeEnd = momentEndDate
      }

      output.push({
        startDate: currentRangeStart.format('YYYY-MM-DD'),
        endDate: currentRangeEnd.format('YYYY-MM-DD')
      })

      currentRangeStart.add(maxDays, 'days')

    } while (currentRangeStart < momentEndDate)

    return output

  },

}

export default DateTimeUtils
